<div class="navbar">
  <div class="wrap">
    <div class="container-fluid d-flex">
      <div class="navbar-logo" *ngIf="!isBayerCaddy">
        <a href="/home" id="header-buyerCaddyLogo">
          <img src="/assets/images/logo.png" alt="salescaddi.ai logo" width="135px" />
        </a>
      </div>
      <div class="navbar-logo" *ngIf="isBayerCaddy" role="button" (click)="goTo('/buyer-home')">
        <!-- <a href="/buyer-home" id="header-buyerCaddyLogo">
          <img src="/assets/images/logoFinal.svg" alt="salescaddi.ai logo" width="135px" />
        </a> -->
      </div>
      <div class="navbar-menu" *ngIf="!isBayerCaddy">

        <a routerLink="/home" class="navbar-menu-item" routerLinkActive="active" id="header-link-toHome">
          Home
        </a>
        <a routerLink="/contact" class="navbar-menu-item" routerLinkActive="active" id="header-link-toSearch">
          Search
        </a>
        <a routerLink="/meetings" class="navbar-menu-item" routerLinkActive="active" id="header-link-toMeetings">
          Meetings
        </a>
        <a routerLink="/insights" class="navbar-menu-item" routerLinkActive="active" id="header-link-toLeads">
          Leads
        </a>
      </div>
      <div class="navbar-menu d-flex" *ngIf="isBayerCaddy">
        <a routerLink="/buyer-home" class="navbar-menu-item" routerLinkActive="active" id="header-link-toBuyerHome">
          Home
        </a>
        <a routerLink="/products" class="navbar-menu-item" routerLinkActive="active" id="header-link-toSearch">
          Search
        </a>
        <app-auto-open-menu>
          <div trigger>
            <a routerLink="/transformation-journeys" *ngIf="isBayerCaddy" class="navbar-menu-item"
              routerLinkActive="active" id="header-link-toTechStacks">
              Tech Stacks
            </a>
          </div>
          <div content id="header-techStacks-menu">
            <button mat-menu-item routerLink="/tech-stack-visualizer" routerLinkActive="active" id="techStacksMenu-link-toVisualizer">
              <mat-icon>
                visibility
              </mat-icon>
              Visualizer
            </button>
            <button mat-menu-item routerLink="/tech-editor" routerLinkActive="active" id="techStacksMenu-link-toCircuit">
              <mat-icon>
                account_tree
              </mat-icon>
              Circuit Board
            </button>
            <button mat-menu-item routerLink="/buyer-insights" routerLinkActive="active" id="techStacksMenu-link-toInsights">
              <mat-icon>
                insights
              </mat-icon>
              Analyze Insights
            </button>
            <button mat-menu-item routerLink="/setup-cohorts" routerLinkActive="active" id="techStacksMenu-link-toCohorts">
              <mat-icon>
                workspaces
              </mat-icon>
              Cohorts
            </button>
          </div>
        </app-auto-open-menu>
        <a *ngIf="this.userProfileDataService.userProfileData?.company" [routerLink]="null" (click)="gotoCompanyPage()"
          class="navbar-menu-item" role="button" [ngClass]="{ active: isCurrentPage('/company/' + dynamicParam) }" id="header-link-toCompany">
          My Companies
        </a>
        <a routerLink="/my-contacts" role="button" class="navbar-menu-item" routerLinkActive="active" id="header-link-toMyProfiles">
          My Profiles
        </a>
        <a routerLink="/buyer-insights" class="navbar-menu-item" routerLinkActive="active" id="header-link-toInsights">
          Insights
        </a>
      </div>
      <div class="d-flex align-items-center">


        <button mat-button [matMenuTriggerFor]="companyMenu" *ngIf="this.companies?.length >= 2" style="max-width: 200px !important; overflow: hidden;">
          <div class="d-flex align-items-center w-100">
            <clearbit-logo *ngIf="selectedCompany?.domain" [domain]="selectedCompany?.domain" [height]="23" class="me-2 flex-shrink-0"></clearbit-logo>
            <div class="text-container flex-grow-1 me-2">
              <span class="text-truncate white-color d-block">{{selectedCompany?.name}}</span>
            </div>
            <mat-icon class="ms-auto white-color flex-shrink-0">keyboard_arrow_down</mat-icon>
          </div>
        </button>
        <mat-menu #companyMenu="matMenu">
          <a *ngFor="let company of this.companies" mat-menu-item (click)="changeCompany(company)"
          class="d-flex align-items-center company-menu-item"
          [disabled]="company.id == this.selectedCompany?.id">
         <div class="d-flex align-items-center w-100">
           <clearbit-logo *ngIf="company?.domain" [domain]="company?.domain" [height]="23" class="me-2 flex-shrink-0"></clearbit-logo>
           <div class="text-container flex-grow-1 me-4">
             <b *ngIf="company.id == this.profileCompanyId" class="text-truncate d-block">{{company.name}}</b>
             <span *ngIf="company.id != this.profileCompanyId" class="text-truncate d-block">{{company.name}}</span>
           </div>
           <mat-icon *ngIf="company.id != this.profileCompanyId && company.id != this.selectedCompany?.id"
                     class="flex-shrink-0 ms-auto me-0"
                     style="font-size: 16px; line-height: 23px;"
                     (click)="this.deleteCompanyFromManagmentList(company.id)">close</mat-icon>
         </div>
       </a>
        </mat-menu>




        <div class="navbar-btn d-flex align-items-center">
          <div class="alert alert-warning mt-2 me-2 p-2" role="alert" *ngIf="this.isUserAs">
            <div class="d-flex justify-content-end  align-items-center ms-2 white-color">
              <span>You are logged in as <b>{{this.userNameAs}}</b></span>
              <button class="btn btn-sm btn-primary ms-2" (click)="onLogoutAs()" id="header-button-logout">LogOut</button>
            </div>
          </div>

          <div class="navbar-userpic">
            <button class="btn" mat-button [matMenuTriggerFor]="menu" disableRipple id="header-button-menuTrigger">
              <div class="d-flex align-items-center user-menu-text">
                <div class="navbar-avatar">
                  <img src="{{ this.authService.getUserClaims()?.picture}} " alt="">
                </div>
                <span>{{ userName }}</span>
                <mat-icon>keyboard_arrow_down</mat-icon>
              </div>
            </button>
            <div class="dropdown-menu dropdown-menu-right">
              <mat-menu #menu="matMenu">

                <a class="dropdown-item" routerLink="/profile" mat-menu-item routerLinkActive="active" href  id="header-button-toProfile">
                  <i class="fal fa-address-book me-2"></i>
                  My Profile
                </a>
                <a *ngIf="isBayerCaddy" class="dropdown-item" routerLink="/setup-cohorts" mat-menu-item
                  routerLinkActive="active" href id="header-button-linkToCohorts">
                  <i class="fal fa-pencil me-2"></i>
                  My Cohorts
                </a>
                <a class="dropdown-item" (click)="onLogout()" stopPropagation mat-menu-item href id="header-button-logout">
                  <i class="fal fa-sign-out-alt me-2"></i>
                  Log out
                </a>
              </mat-menu>
            </div>
          </div>
        </div>
      </div>
      <!-- <button *ngIf="!isBayerCaddy" mat-raised-button color="warn"  class="navbar-btn-item ms-4 " style="font-size: 18px; font-weight: 500;"
              (click)="switchToBuyerCaddy()" matTooltip="Switch to BuyerCaddy">
        BuyerCaddy
      </button>

      <button *ngIf="isBayerCaddy" mat-raised-button color="accent"  class="navbar-btn-item ms-4 " style="font-size: 18px; font-weight: 500;"
              (click)="switchToSalesCaddy()" matTooltip="Switch to SalesCaddy">
        SalesCaddy
      </button> -->
    </div>

  </div>
</div>

<button *ngIf="showAiChat" class="ai-chat-button" (click)="startAi()">
<img src="../../../../assets/images/ai/rachel-ai10.png" width="40px" height="40px" style=" border-radius: 50%;" alt="Rachel" class="profile-pic me-3" />
  Ask Rachel
</button>

